import { FetchAllChallansAPIResponse } from '../../../services/outwardChallans'
import { BaseReducerState, Challan } from '../../../services'
import { ActionTypes } from '../actions'

export type FetchAllChallansState = BaseReducerState & {
  data: Challan[]
}

export const initialState: FetchAllChallansState = {
  loading: false,
  success: false,
  message: '',
  data: null,
  error: null,
}

export const fetchAllChallans = (
  state: FetchAllChallansState = initialState,
  action: { type: string; res: any }
): FetchAllChallansState => {
  switch (action.type) {
    case `${ActionTypes.FETCH_ALL_CHALLANS}_REQUEST`:
      return {
        ...state,
        loading: true,
        success: false,
        message: null,
        // Keep existing data during reload to prevent flicker
        error: null,
      }

    case `${ActionTypes.FETCH_ALL_CHALLANS}_SUCCESS`: {
      const { success, data, message } = <FetchAllChallansAPIResponse>action.res
      return {
        ...state,
        loading: false,
        success,
        message,
        ...(success && data && { data }),
      }
    }
    case `${ActionTypes.FETCH_ALL_CHALLANS}_FAILURE`:
      const res = <FetchAllChallansAPIResponse>action.res
      const { message } = res || {}
      res.error ??= message
      const { error } = res
      return {
        ...state,
        loading: false,
        success: false,
        message,
        error,
      }

    case `${ActionTypes.FETCH_ALL_CHALLANS}_RESET`:
      return {
        ...initialState,
      }
  }
  return state
}